import { render, staticRenderFns } from "./SpecialNewsList.vue?vue&type=template&id=50823806&scoped=true&lang=html"
import script from "./SpecialNewsList.vue?vue&type=script&lang=js"
export * from "./SpecialNewsList.vue?vue&type=script&lang=js"
import style0 from "./SpecialNewsList.vue?vue&type=style&index=0&id=50823806&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50823806",
  null
  
)

export default component.exports